<template>
  <div class="page-content submitShenhe" :style="defaultHeight">
    <div class="startTitle">机构入驻</div>
    <el-row>
      <el-col :span="16" :offset="4" >
        <ul class="stepBox">
          <li class="stepText">
            <img src="../../assets/images/back/step.png" alt="">
            <span class="act">基本信息</span>
          </li>
          <li class="stepLine act"></li>
          <li class="stepText">
            <img src="../../assets/images/back/step.png" alt="">
            <span class="act">相关资质</span>
          </li>
          <li class="stepLine act"></li>
          <li class="stepText">
            <img src="../../assets/images/back/step.png" alt="">
            <span class="act">提交审核</span>
          </li>
        </ul>
      </el-col>
    </el-row>


    <el-row style="margin-top: 80px;margin-bottom: 50px" v-if="shenheStatus==0">
      <el-col :span="14" :offset="5" >
        <img class="submitShenheimg" src="../../assets/images/back/submitShenhe.png" alt="">
        <h2>机构入驻审核中</h2>
        <div class="subtip">机构入驻申请审核中，一般需要3-5天时间，审核完成后会以短信的发送到您的手机，敬请留意</div>
      </el-col>
    </el-row>

    <el-row style="margin-top: 80px;margin-bottom: 50px" v-if="shenheStatus==1">
      <el-col :span="14" :offset="5" >
        <img class="submitShenheimg" src="../../assets/images/back/submitShenhe.png" alt="">
        <h2>机构入驻审核成功</h2>
<!--        <div class="subtip">机构入驻申请审核中，一般需要3-5天时间，审核完成后会以短信的发送到您的手机，敬请留意</div>-->
      </el-col>
    </el-row>

    <el-row style="margin-top: 80px;margin-bottom: 50px" v-if="shenheStatus==2">
      <el-col :span="14" :offset="5" >
        <img class="submitShenheimg" src="../../assets/images/back/submitShenheNo.png" alt="">
        <h2 class="submitShenheno">机构入驻审核未通过</h2>
        <div class="subtip">机构入驻审核失败，失败原因：您的营业执照信息与您的的经营信息不符，请确认信息后重新审核</div>
        <el-button type="info" class="submitShenheno_Btn" @click="cxXinxi()">重新提交审核信息</el-button>
      </el-col>
    </el-row>



  </div>
</template>

<script>
    import '@/assets/css/backcommon.css'
    import Cookies from 'js-cookie'
    import {mechanismSettleIn} from '@/api/myInfo'
    export default {
        name: "jsgou_submitShenhe",
        data() {
            return {
                defaultHeight: {
                    height: ""
                },
                shenheStatus:-1
            }
        },
        components: {},
        beforeMount(){
            this.userId=this.$store.state.user.userId;
            if(this.userId===""){
                console.log(Cookies.get("userInfo"));
                this.userId=JSON.parse(Cookies.get("userInfo"))["userId"];
            }
        },
        mounted(){
            //页面创建时执行一次getHeight进行赋值，顺道绑定resize事件
            window.addEventListener("resize", this.getHeight);
            this.getHeight();
            this.mechanismSettleIn();
        },
        methods: {
            //定义方法，获取高度减去头尾
            getHeight() {
                this.defaultHeight.height = window.innerHeight - 105 + "px";
            },
            message(text){
                this.$message({
                    message:text,
                    type: 'warning'
                });
            },
            mechanismSettleIn(){
                var thi=this;
                mechanismSettleIn(this.userId).then(res=>{
                    if (parseFloat(res.data.code)=== 200) {
                        if(parseInt(res.data.data.status)===0){//审核中
                            thi.shenheStatus=0
                        }else if(parseInt(res.data.data.status)===2){//审核失败
                              thi.shenheStatus=2
                        }else {//审核成功
                            thi.shenheStatus=1
                        }
                    } else {
                        thi.shenheStatus=-1;
                        thi.message(res.data.msg);
                    }
                });
            },
            cxXinxi(){
                this.$router.push("/personCenter/zizhiAuth/zizhiAuthJigou_jbxx?isModifyData=true")
            }
        },
    }
</script>

<style scoped>
.submitShenheimg{
  width: 90px;
  height: 90px;
  display: block;
  margin: 0 auto;
}
.submitShenhe h2{
  text-align: center;
  font-size:30px;
  line-height: 80px;
  font-weight:800;
  color:rgba(255,149,0,1);
}
.submitShenhe h2.submitShenheno{
  color:#FF5454;
}
.submitShenhe .subtip{
  display: block;
  font-size: 14px;
  color: #606266;
  text-align: center;
  line-height: 20px;
}
.submitShenheno_Btn{
  display: block;
  margin: 30px auto;
}

</style>




// WEBPACK FOOTER //
// src/views/personCenter/jsgou_submitShenhe.vue